import React, {useContext} from 'react';
import {Link, Redirect, useParams} from 'react-router-dom';
import DeviceContainer from '../device-container';
import styled from 'styled-components';
import RoundButton from '../../components/roundButton';
import I18nMessage from '../../components/I18nMessage';
import AccountContainer from '../account-container';
import UserContainer from '../user-container';
import GroupContainer from '../group-container';
import GeofenceContainer from '../geofence-container';
import DriverContainer from '../driver-container';
import NotificationContainer from '../notification-container';
import ServerContainer from '../server-container';
import CalendarContainer from '../calendar-container';
// import MaintenanceContainer from '../maintenance-container';
import CustomerContainer from '../customer-container';
import {ThemeContext} from '../../apiContexts';
import SinisterContainer from '../sinister-container';
import MaintenanceAdminLayout from 'src/autobahn/features/maintenance/admin-layout';
import MaintenanceRegisteredTab from 'src/autobahn/features/maintenance/registered-tab';
import MaintenanceProvider from 'src/autobahn/features/maintenance/provider';
import MaintenanceUpcomingTab from 'src/autobahn/features/maintenance/upcoming-tab';
import MaintenanceOngoingTab from 'src/autobahn/features/maintenance/ongoing-tab';
import MaintenanceCompletedTab from 'src/autobahn/features/maintenance/completed-tab';
import CompanyAdminLayout from 'src/autobahn/features/company/admin-layout';
import IntegrationContainer from 'src/autobahn/features/integration/container';
import IntegrationConfigContainer from 'src/autobahn/features/integration-config/container';
import BillingContainer from '../financial-container';
import {isCurrentProfileAdmin} from 'src/helpers/profile';
import ReportJobsContainer from 'src/autobahn/features/report-jobs/container';

const Content = styled.div`
  background-color: white;
  height: 100%;
  width: 100%;
  position: relative;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  border-radius: 12px;
  padding: 20px 40px 20px 40px;
  
  .react-bs-table-pagination {
    text-align: left;
  }
  
  .form-title {
    padding: 15px;
  }
  
  .rounded-group-button-form {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .rounded-group-button-form-bottom {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .custom-formGroup{
    text-align: left;
  }
`;

const H2Styled = styled.h2`
  color: ${(props) => props.theme};
`;

const VIEWS_EXCLUDING_HEADER = [
    'maintenance',
    'company',
];

const AdminFormContainer = () => {
    const {view} = useParams();
    const theme = useContext(ThemeContext);

    const getFormName = () => {
        switch ( view ) {
            case 'device': return 'sharedDevice';
            case 'account': return 'settingsUser';
            case 'users': return 'settingsUsers';
            case 'groups': return 'groupDialog';
            case 'geofences': return 'sharedGeofence';
            case 'sinister': return 'sharedSinister';
            case 'drivers': return 'sharedDriver';
            case 'notifications': return 'sharedNotification';
            case 'calendars': return 'sharedCalendar';
            case 'server': return 'settingsServer';
            case 'maintenance': return 'sharedMaintenance';
            case 'customers': return 'sharedCustomers';
            case 'company': return 'sharedCompany';
            case 'integrations': return 'sharedIntegration';
            case 'integrationconfig': return 'sharedIntegrationConfig';
            case 'reportjobs': return 'sharedReportJobs';
            case 'billing': return 'sharedFinancial';
        }
    };

    return (
        <Content className="custom-shadow-2">
            {!VIEWS_EXCLUDING_HEADER.includes(view) ? (
                <div id={'container'}>
                    <div className={'float-left'}>
                        <H2Styled theme={theme} className={'form-title'}>
                            <I18nMessage id={getFormName()}/>
                        </H2Styled>
                    </div>
                    <RoundButton className="mt-3 mb-3 float-right" tag={Link} to={'/admin'}>
                        <span className="fas fa-times text-secondary" />
                    </RoundButton>
                    <div className={'clearfix'}>&nbsp;</div>
                </div>
            ) : null}
            {
                {
                    device: (
                        <DeviceContainer />
                    ),
                    account: (
                        <AccountContainer />
                    ),
                    users: (
                        <UserContainer />
                    ),
                    groups: (
                        <GroupContainer />
                    ),
                    geofences: (
                        <GeofenceContainer />
                    ),
                    sinister: (
                        <SinisterContainer />
                    ),
                    drivers: (
                        <DriverContainer />
                    ),
                    notifications: (
                        <NotificationContainer />
                    ),
                    calendars: (
                        <CalendarContainer />
                    ),
                    maintenance: (
                        <MaintenanceProvider>
                            <MaintenanceAdminLayout>
                                <MaintenanceRegisteredTab />
                                <MaintenanceUpcomingTab />
                                <MaintenanceOngoingTab />
                                <MaintenanceCompletedTab />
                            </MaintenanceAdminLayout>
                        </MaintenanceProvider>
                    ),
                    server: (
                        <ServerContainer />
                    ),
                    customers: (
                        <CustomerContainer />
                    ),
                    // A NavVertical esconde este item do menu pra quem nao e admin (filterLinks
                    // em admin-container.jsx), mas isso nao impede digitar a URL direto -- a
                    // lista aqui lista TODAS as empresas/centrais, sem escopo por customer.
                    company: (
                        isCurrentProfileAdmin() ? <CompanyAdminLayout /> : <Redirect to="/admin" />
                    ),
                    integrations: (
                        <IntegrationContainer />
                    ),
                    integrationconfig: (
                        <IntegrationConfigContainer />
                    ),
                    reportjobs: (
                        <ReportJobsContainer />
                    ),
                    billing: (
                        <BillingContainer />
                    ),
                }[view]
            }
        </Content>
    );
};

export default AdminFormContainer;
